import CodeEventBus from '../code/CodeEventBus'
import CodeProfile from '../code/CodeProfile'
import UrlsConfig from '../config/urls.conf'

export default {
  install (Vue) {
    const eventBus = new Vue()

    const showEventBusLog = function (eventType, ...args) {
      console.log(`EVENT BUS - [ ${eventType} ]`, args)
    }

    if (UrlsConfig.profile !== CodeProfile.PROD) {
      for (let k of Object.keys(CodeEventBus)) {
        eventBus.$on(k, (...args) => {
          showEventBusLog(k, ...args)
        })
      }
    }

    Object.defineProperty(Vue.prototype, '$eventBus', {
      get () {
        return eventBus
      }
    })

    Object.defineProperty(Vue.prototype, '$showToast', {
      get () {
        return function(toastMessage) {
          eventBus.$emit(CodeEventBus.SHOW_TOAST, {
            toastMessage
          })
        }
      }
    })


    Object.defineProperty(Vue.prototype, '$showSpinner', {
      get () {
        return function(showSpinner) {
          eventBus.$emit(CodeEventBus.SHOW_SPINNER, {
            showSpinner
          })
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globalPrototypes.js